export default __webpack_public_path__ + "static/hero-image-6737f3a953781a244d0744e3d0c0f34a.png";